__turbopack_context__.v({
  "avatar": "cd3mOq_avatar",
  "avatarContainer": "cd3mOq_avatarContainer",
  "button": "cd3mOq_button",
  "calendarAction": "cd3mOq_calendarAction",
  "container": "cd3mOq_container",
  "copy": "cd3mOq_copy",
  "copyAndPrimaryButtons": "cd3mOq_copyAndPrimaryButtons",
  "dismissIcon": "cd3mOq_dismissIcon",
  "eventIcon": "cd3mOq_eventIcon",
  "message": "cd3mOq_message",
  "multipleButtons": "cd3mOq_multipleButtons",
  "timestamp": "cd3mOq_timestamp",
});
